<template>
  <div name="reports">
    <div v-if="errored" class="ml-10 mt-4 font-bold text-red-400">
      <p>
        We are not able to retrieve this information at the moment, please try
        back later
      </p>
    </div>

    <div id="content-area" class="mx-4" v-else>
      <div id="printable" class="" v-if="hasAccess" >
          <assessmentChart
            :assessmentData="orderedAssessments"
          ></assessmentChart>
      </div>
      <div v-else>
        <UpgradeContent :area="'Reporting'"></UpgradeContent>
      </div>

    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ReportingService } from "@/services/reporting.service"

const assessmentChart = () =>
  import("@/components/charts/TheAssessmentChart.vue");

const UpgradeContent = () => import("@/components/upgrade/UpgradeContent.vue");

export default {
  name: "reports",
  props: ["filterValues", "hasAccess"],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    componentLoaded() {
      return this.orderedAssessments.length > 0;
    },
    orderedAssessments() {
      return this.pupilAssessments 
    },
  },
  data() {
    return {
      loading: true,
      pupilAssessments: [],
      errored: false,
      page: 1,
      pageSize: 999,
      currentPage: 1,
      pagination: {},
    };
  },
  created() {

  },
  mounted() {
    
    this.refresh()
  },
  watch: {
    '$props':{
      handler: function (val, oldVal) { 
        this.refresh()
      },
      deep: true
    }
  },
  methods: {
    refresh() {
      this.fetchAssessmentWithFilter()
    },
    fetchAssessmentWithFilter() {
        ReportingService.getAssessmentsWithFilter(this.filterValues, this.page, this.pageSize)
          .then((response) => this.buildAssessmentList(response.data.data))
          .catch((err) => {
            console.log("Activities " + err);
            this.errored = true;
          })
          .finally(() => (this.loading = false));
      },
      buildAssessmentList(data) {
        this.pupilAssessments = data;
      },
  },
  components: {
    assessmentChart,
    UpgradeContent,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
